module.exports = __webpack_public_path__ + "img/A11a_20120205-001.9b961e2d.jpg";